// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--3Wzje","gated":"index-module--gated--NwHbI"};